import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';

import img from '../../../../assets/system-error.png';

const useStyles = makeStyles({
  card: {
    minWidth: 275,
  },
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)',
  },
  title: {
    fontSize: 14,
  },
  pos: {
    marginBottom: 12,
  },
});

export default function Error(props) {
  const classes = useStyles();

  return (
    <Card className={classes.card}>
      <CardContent>
        <img src={img} width="100"/>
        <br/><br/>
        <Typography className={classes.title} color="textSecondary" gutterBottom>
          {props.text}
        </Typography>
      </CardContent>
    </Card>
  );
}
